module.exports = __webpack_public_path__ + "img/write-icon.4717b937.png";